export const loginInputFields = [
  {
    id: 1,
    name: "email",
    type: "email",
    placeholder: "Enter your email",
    label: "Email:",
  },
  {
    id: 2,
    name: "password",
    type: "password",
    placeholder: "Enter your password",
    label: "Password:",
  },
];

export const registerInputFields = [
  {
    id: 1,
    name: "firstname",
    type: "text",
    placeholder: "Enter your firstname",
    label: "Firstname:",
  },
  {
    id: 2,
    name: "lastname",
    type: "text",
    placeholder: "Enter your lastname",
    label: "Lastname:",
  },
  {
    id: 3,
    name: "username",
    type: "text",
    placeholder: "Enter your username",
    label: "Username:",
  },
  {
    id: 4,
    name: "password",
    type: "password",
    placeholder: "Enter your password",
    label: "Password:",
  },
  {
    id: 5,
    name: "confirmPassword",
    type: "password",
    placeholder: "Confirm your password",
    label: "Password confirmation:",
  },
  {
    id: 6,
    name: "email",
    type: "email",
    placeholder: "Enter your email",
    label: "Email:",
  },
];
